module.exports = __webpack_public_path__ + "img/logo_teleport.5a509005.png";